import api from "@/plugins/axios";

export const loginService = async (username, pass) => {
  const response = await api.post("/auth/login", { username, pass });
  return response.data;
};

export const logoutService = async () => {
  const response = await api.post("/auth/logout");
  return response.data;
};
